import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayToString',
})
export class ArrayToStringPipe implements PipeTransform {
  transform(array: string[], separator= ',', connector = ' and'): string {
    if(!Array.isArray(array)) return array;
    let str = array.map(s=>" "+s).toString();
    if(separator === ',') str = str.substring(0,str.lastIndexOf(',')) + connector + str.substring(str.lastIndexOf(',')+1);
    str = str?.replace(new RegExp(',', 'g'), " "+separator);
    return str;
  }
}
